"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MyContext = void 0;
var react_1 = require("react");
exports.MyContext = (0, react_1.createContext)(null);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29udGV4dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImNvbnRleHQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsK0JBQXFDO0FBRXhCLFFBQUEsU0FBUyxHQUFHLElBQUEscUJBQWEsRUFBQyxJQUFXLENBQUMsQ0FBQSJ9